exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-section .template-download[data-v-e060f1e6], .import-section .file-upload[data-v-e060f1e6], .import-section .uploaded-file[data-v-e060f1e6] {\n  margin-bottom: 15px;\n}\n.import-section .template-download .label[data-v-e060f1e6], .import-section .file-upload .label[data-v-e060f1e6], .import-section .uploaded-file .label[data-v-e060f1e6] {\n    display: inline-block;\n    width: 80px;\n    font-weight: 500;\n}\n.import-section .uploaded-file .el-tag[data-v-e060f1e6] {\n  margin-left: 10px;\n}\n.dialog-footer[data-v-e060f1e6] {\n  text-align: right;\n}\n", ""]);

// exports
